import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from '@shared/button/button.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-print',
  imports: [
    ButtonComponent
  ],
  templateUrl: './viewer-print.component.html',
  styleUrl: './viewer-print.component.scss'
})
export class ViewerPrintComponent {

  @Output() triggerPrint = new EventEmitter<boolean>();

  protected readonly zbpIconNames = zbpIconNames;

  printImage(): void {
    this.triggerPrint.emit(true);
  }
}
